import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './DockAppointments.frontend.types'

@Injectable({ providedIn: 'root' })
export class DockAppointments_create_dock_appointment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { order_ids?: number[], load_container_id?: number, lookupcode?: string, warehouse_id: number, scheduled_arrival?: string, scheduled_departure?: string, reference_number?: string, notes?: string, carrier_id?: number, scheduled_owner_id?: number, scheduled_project_id?: number, appointment_type_id?: number, dock_door_id?: number, user?: string, shipment_id?: number }): Promise<{ dock_appointment_id: number, reason?: string, dockappointment?: any }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/functions/create_dock_appointment_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

